// Browser Run side-panel editor.
//
// Two hyperparameters: Goal (what to do) + Start URL (where to do it).
// When the node fires at runtime, the api ships these to the Chrome
// extension over the ws bridge; the extension opens the URL, runs the
// AI loop, and auto-closes its popup + tab when done.

const React = require('react');
const { useEffect, useState } = React;
const { createElement: h } = React;
const apiClient = require('../lib/apiClient');
const VariableAutocompleteInput = require('./VariableAutocompleteInput');

// Poll the api once on mount + every 4s so the editor can show a hint
// when the Chrome extension isn't connected. Non-blocking — the node
// still saves and runs without a connection (the runtime surfaces the
// real "not connected" error on the failed branch).
function useConnectionStatus(pollMs) {
  const [status, setStatus] = useState({ connected: false, checked: false });
  useEffect(function () {
    let cancelled = false;
    function tick() {
      apiClient.request('/browser-run/status', { method: 'GET' })
        .then(function (res) {
          if (cancelled) return;
          setStatus({ connected: !!(res && res.connected), checked: true });
        })
        .catch(function () {
          if (cancelled) return;
          setStatus({ connected: false, checked: true });
        });
    }
    tick();
    const iv = setInterval(tick, pollMs || 4000);
    return function () { cancelled = true; clearInterval(iv); };
  }, [pollMs]);
  return status;
}

function LabeledRow(props) {
  return h('div', { className: 'wf-params-row' },
    h('div', { className: 'wf-params-row-label' }, props.label),
    h('div', { className: 'wf-params-row-control' }, props.children)
  );
}

function BrowserRunRecorderEditor(props) {
  const paramValues   = props.paramValues || {};
  const onParamChange = props.onParamChange || function () {};
  const variableNodes = props.variableNodes || [];
  const conn = useConnectionStatus(4000);

  const goal       = String(paramValues.goal || '');
  const webpageUrl = String(paramValues.webpageUrl || '');

  return h('div', { className: 'wf-params-form' },
    h(LabeledRow, { label: 'Goal' },
      h(VariableAutocompleteInput, {
        value: goal,
        placeholder: 'e.g. Search for "wireless headphones" and open the first result (use @ for a variable)',
        variableNodes: variableNodes,
        onChange: function (next) { onParamChange('goal', next); }
      })
    ),
    h(LabeledRow, { label: 'Start URL' },
      h(VariableAutocompleteInput, {
        value: webpageUrl,
        placeholder: 'https://example.com (or @variable)',
        variableNodes: variableNodes,
        onChange: function (next) { onParamChange('webpageUrl', next); }
      })
    ),
    !conn.connected && conn.checked ? h('div', {
      className: 'wf-params-hint',
      style: { color: '#a88', fontSize: 12, marginTop: 4 }
    }, 'Chrome extension not connected. Install the Alleflow Browser Run extension and reload this page.') : null
  );
}

module.exports = BrowserRunRecorderEditor;
